var map = {
	"./action.svg": 180,
	"./adventure.svg": 181,
	"./advertorial.svg": 182,
	"./album.svg": 183,
	"./analysis.svg": 184,
	"./anchor.svg": 185,
	"./android-block.svg": 186,
	"./android-small.svg": 187,
	"./android.svg": 188,
	"./angle-down.svg": 189,
	"./angle-left.svg": 190,
	"./angle-right.svg": 191,
	"./angle-up.svg": 192,
	"./app-exclusive.svg": 193,
	"./aquarius.svg": 194,
	"./arcade.svg": 195,
	"./aries.svg": 196,
	"./arrow-down.svg": 197,
	"./arrow-left.svg": 198,
	"./arrow-right.svg": 199,
	"./arrow-up.svg": 200,
	"./arrow.svg": 201,
	"./art-director.svg": 202,
	"./astrology.svg": 203,
	"./author.svg": 204,
	"./authoranchor.svg": 205,
	"./automobile.svg": 206,
	"./backward.svg": 207,
	"./bigboss.svg": 208,
	"./bigboss_icon.svg": 209,
	"./bookmark.svg": 210,
	"./books-vikatan.svg": 211,
	"./brandconnect.svg": 212,
	"./breaking-news.svg": 213,
	"./bullet-arrow.svg": 214,
	"./bundle.svg": 215,
	"./business.svg": 216,
	"./calendar.svg": 217,
	"./cancel.svg": 218,
	"./cancer.svg": 219,
	"./canvas.svg": 220,
	"./capricorn.svg": 221,
	"./cartoonist.svg": 222,
	"./cinema.svg": 223,
	"./clapboard.svg": 224,
	"./clipboard.svg": 225,
	"./close.svg": 226,
	"./comm-album.svg": 227,
	"./comm-automobile.svg": 228,
	"./comm-children.svg": 229,
	"./comm-cinema.svg": 230,
	"./comm-entertainment.svg": 231,
	"./comm-environment.svg": 232,
	"./comm-finance.svg": 233,
	"./comm-gadgets.svg": 234,
	"./comm-health.svg": 235,
	"./comm-lifestyle.svg": 236,
	"./comm-news.svg": 237,
	"./comm-science.svg": 238,
	"./comm-spiritual.svg": 239,
	"./comm-sports.svg": 240,
	"./comm-technology.svg": 241,
	"./comm-video.svg": 242,
	"./comm-vikatan-plus.svg": 243,
	"./comm-women.svg": 244,
	"./comm-world-cup.svg": 245,
	"./comment.svg": 246,
	"./corona-updates-icon.svg": 247,
	"./creative-director.svg": 248,
	"./cricket.svg": 249,
	"./crime.svg": 250,
	"./data.svg": 251,
	"./designed.svg": 252,
	"./double-arrow.svg": 253,
	"./downarrow.svg": 254,
	"./download.svg": 255,
	"./edit.svg": 256,
	"./edited-by.svg": 257,
	"./email.svg": 258,
	"./environment.svg": 259,
	"./exclusivedeals.svg": 260,
	"./facebook-bg.svg": 261,
	"./facebook-icon.svg": 262,
	"./facebook.svg": 263,
	"./filter-icon.svg": 264,
	"./filter.svg": 265,
	"./food-stylist.svg": 266,
	"./forward.svg": 267,
	"./gallery.svg": 268,
	"./game-shop.svg": 269,
	"./gemini.svg": 270,
	"./group.svg": 271,
	"./gzhome.svg": 272,
	"./gzsports.svg": 273,
	"./gztrending.svg": 274,
	"./health.svg": 275,
	"./hexbackground.svg": 276,
	"./humoursatire-entertainment.svg": 277,
	"./illustrator-t1.svg": 278,
	"./illustrator.svg": 279,
	"./infographer.svg": 280,
	"./instagram.svg": 281,
	"./interviews.svg": 282,
	"./ios-block.svg": 283,
	"./ios-small.svg": 284,
	"./ios.svg": 285,
	"./jokes.svg": 286,
	"./leo.svg": 287,
	"./libra.svg": 288,
	"./lifestyle.svg": 289,
	"./line-arrow-next.svg": 290,
	"./line-arrow-prev.svg": 291,
	"./linkedin.svg": 292,
	"./listicle.svg": 293,
	"./live-chat.svg": 294,
	"./liveupdate.svg": 295,
	"./log green.svg": 296,
	"./log grey.svg": 297,
	"./log white.svg": 298,
	"./logic.svg": 299,
	"./login-facebook.svg": 300,
	"./login-google.svg": 301,
	"./login.svg": 302,
	"./logout-mobile.svg": 303,
	"./logout.svg": 304,
	"./longform.svg": 305,
	"./magazines.svg": 306,
	"./menu-search.svg": 307,
	"./microphone.svg": 308,
	"./minus.svg": 309,
	"./mobile-share.svg": 310,
	"./moderated.svg": 311,
	"./more-outline.svg": 312,
	"./mynews.svg": 313,
	"./myvikatanbadge.svg": 314,
	"./narrated.svg": 315,
	"./news.svg": 316,
	"./newsletter.svg": 317,
	"./newslettericon.svg": 318,
	"./olympic.svg": 319,
	"./online-news.svg": 320,
	"./pause.svg": 321,
	"./paywalliconbenefit.svg": 322,
	"./paywalliconbenefitfour.svg": 323,
	"./paywalliconbenefitthree.svg": 324,
	"./paywalliconbenefittwo.svg": 325,
	"./pdf.svg": 326,
	"./pen.svg": 327,
	"./personalise.svg": 328,
	"./phone.svg": 329,
	"./photo.svg": 330,
	"./photographer.svg": 331,
	"./photostory.svg": 332,
	"./pisces.svg": 333,
	"./play.svg": 334,
	"./plus.svg": 335,
	"./podcast.svg": 336,
	"./podcast_vikatan_menu.svg": 337,
	"./poems.svg": 338,
	"./politics-all.svg": 339,
	"./premium.svg": 340,
	"./producer.svg": 341,
	"./proofread.svg": 342,
	"./published-by.svg": 343,
	"./published.svg": 344,
	"./rain.svg": 345,
	"./rss.svg": 346,
	"./rupee.svg": 347,
	"./sagitarius.svg": 348,
	"./scorpio.svg": 349,
	"./script-writer.svg": 350,
	"./scripted.svg": 351,
	"./search.svg": 352,
	"./share-alt.svg": 353,
	"./share.svg": 354,
	"./sharechat.svg": 355,
	"./shortform.svg": 356,
	"./shortstories.svg": 357,
	"./shortvideo.svg": 358,
	"./slider-next.svg": 359,
	"./slider-prev.svg": 360,
	"./socialshare.svg": 361,
	"./sort.svg": 362,
	"./sound.svg": 363,
	"./speaker.svg": 364,
	"./speakeraudio.svg": 365,
	"./spiritual.svg": 366,
	"./sponsored.svg": 367,
	"./sports.svg": 368,
	"./star.svg": 369,
	"./stories.svg": 370,
	"./strategy.svg": 371,
	"./stylist.svg": 372,
	"./subscribe-vikatan.svg": 373,
	"./success-icon.svg": 374,
	"./tag.svg": 375,
	"./taurus.svg": 376,
	"./technology.svg": 377,
	"./text.svg": 378,
	"./thump.svg": 379,
	"./tick.svg": 380,
	"./trending.svg": 381,
	"./twitter-icon.svg": 382,
	"./twitter.svg": 383,
	"./uparrow.svg": 384,
	"./update-black.svg": 385,
	"./user-square.svg": 386,
	"./user.svg": 387,
	"./video-editor.svg": 388,
	"./video-play.svg": 389,
	"./video.svg": 390,
	"./videographer.svg": 391,
	"./vikatan-tv.svg": 392,
	"./vikatanconnect.svg": 393,
	"./vikatanspl.svg": 394,
	"./vikatantv.svg": 395,
	"./virgo.svg": 396,
	"./whatsapp.svg": 397,
	"./women-home.svg": 398,
	"./writtenarticles.svg": 399,
	"./writtenstory.svg": 400,
	"./youtube.svg": 401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 179;